import { useEffect, useState } from "react"
import { AnimatePresence } from "framer-motion"
import { DashboardContainer, Header, Title, ContentArea } from "../components/Dash/styled/Layout"
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from "react-router-dom"
import { useProductos } from "../hooks/useProductos"
import { useSnackbar } from "notistack"
import FormEdit from "../components/FormEdit"
import { Toaster } from 'react-hot-toast';


export default function Dashboard() {
  const navigate = useNavigate()
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        when: "beforeChildren",
      },
    },
  }

  const headerVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  }

  return (
    <DashboardContainer initial="hidden" animate="visible" variants={containerVariants}>
      <Toaster/>
      <Header variants={headerVariants}>
        <Title>Administración</Title>

        <LogoutIcon style={{ cursor: "pointer" }} onClick={() => navigate("/")} />

      </Header>
      <ContentArea>

        <AnimatePresence mode="wait">
           <FormEdit create={true}/>
        </AnimatePresence>
      </ContentArea>
    </DashboardContainer>

  )
}


